$(document).ready(function () {
  $.ajax({
    type: "GET",
    url: "/products/wd-tank-king.js",
    dataType: "json",
    success: function (product) {
      var goods_price = (product.price / 100).toFixed(2);
      $(".wd-compare-product .wd-compare-detail-item")
        .eq(0)
        .find(".wd-compare-detail-item-product-price")
        .html("$" + goods_price);
      $(".wd-compare-header .wd-compare-header-item")
        .eq(0)
        .find(".wd-compare-header-item-price")
        .html("$" + goods_price);
    },
  });
  $.ajax({
    type: "GET",
    url: "/products/wd-tank-king.js",
    dataType: "json",
    success: function (product) {
      var goods_price = (product.variants[1].price / 100).toFixed(2);
      $(".wd-compare-product .wd-compare-detail-item")
        .eq(1)
        .find(".wd-compare-detail-item-product-price")
        .html("$" + goods_price);
      $(".wd-compare-header .wd-compare-header-item")
        .eq(1)
        .find(".wd-compare-header-item-price")
        .html("$" + goods_price);
    },
  });
  $.ajax({
    type: "GET",
    url: "/products/wd-tank-king-f-s.js",
    dataType: "json",
    success: function (product) {
      var goods_price = (product.price / 100).toFixed(2);
      $(".wd-compare-product .wd-compare-detail-item")
        .eq(2)
        .find(".wd-compare-detail-item-product-price")
        .html("$" + goods_price);
      $(".wd-compare-header .wd-compare-header-item")
        .eq(2)
        .find(".wd-compare-header-item-price")
        .html("$" + goods_price);
    },
  });
  $(window).on("scroll", function () {
    var scrollTop = $(this).scrollTop();
    var offsetTop = $(".wd-compare-content").offset().top;
    if (scrollTop > offsetTop) {
      $(".wd-compare-header").css("display", "block");
    } else {
      $(".wd-compare-header").css("display", "none");
    }
  });

  var wd_compare_index;
  var pre_index;

  var window_width = $(window).width();
  if (window_width <= 1024) {
    $(".wd-compare-product .wd-compare-detail-item-product-choose-card-items")
      .eq(0)
      .find(".wd-compare-detail-item-product-choose-card-item")
      .eq(2)
      .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
    $(".wd-compare-product .wd-compare-detail-item-product-choose-card-items")
      .eq(1)
      .find(".wd-compare-detail-item-product-choose-card-item")
      .eq(2)
      .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
  }

  $(".wd-compare-detail-item-product-choose-select").click(function () {
    wd_compare_index = $(this).parents(".wd-compare-detail-item").index();
    pre_index = $(this)
      .siblings(".wd-compare-detail-item-product-choose-card")
      .find(`.wd-compare-detail-item-product-choose-card-item-active`)
      .attr("data-index");

    if (window_width <= 767) {
      $(".wd-compare-detail-item-product-choose-card-popup").css(
        "display",
        "block"
      );
      $(".wd-compare-detail-item-product-choose-select-mobile").css(
        "display",
        "flex"
      );
      $(".wd-compare-detail-item-product-choose-card-popup-close").css(
        "display",
        "block"
      );
      $("html").css("overflow", "hidden");
      $(".wd-compare").css("z-index", "99");
      $(this)
        .siblings(".wd-compare-detail-item-product-choose-select-mobile")
        .css("border-bottom", "1px solid #2179CA");
      $(this)
        .parents(".wd-compare-detail-item")
        .siblings()
        .find(".wd-compare-detail-item-product-choose-select-mobile")
        .css("border-bottom", "1px solid #e2e2e2");
    }
    $(this)
      .parents(".wd-compare-detail-items")
      .find(".wd-compare-detail-item-product-choose-card")
      .stop()
      .slideUp();
    $(this)
      .siblings(".wd-compare-detail-item-product-choose-card")
      .stop()
      .slideDown();
  });

  $(
    ".wd-compare-detail-item-product-choose-select.wd-compare-detail-item-product-choose-select-mobile"
  ).click(function () {
    $(this)
      .parents(".wd-compare-detail-item")
      .siblings()
      .find(".wd-compare-detail-item-product-choose-card")
      .css("display", "none");
    $(this)
      .parents(".wd-compare-detail-item")
      .siblings()
      .find(".wd-compare-detail-item-product-choose-select-mobile")
      .css("border-bottom", "1px solid #e2e2e2");
    $(this)
      .siblings(".wd-compare-detail-item-product-choose-card")
      .css("display", "block");
    $(this).css("border-bottom", "1px solid #2179CA");
  });

  $(".wd-compare-detail-item-product-choose-card").mouseleave(function () {
    $(this).stop().slideUp();
  });
  $(".wd-compare-detail-item-product-choose-card-item").hover(
    function () {
      $(this).addClass("wd-compare-detail-item-product-choose-card-item-hover");
    },
    function () {
      $(this).removeClass(
        "wd-compare-detail-item-product-choose-card-item-hover"
      );
    }
  );
  $(".wd-compare-detail-item-product-choose-card-popup-close").click(
    function () {
      $(this)
        .parents(".wd-compare-detail-items")
        .find(".wd-compare-detail-item-product-choose-card")
        .stop()
        .slideUp();
      $(".wd-compare-detail-item-product-choose-card-popup").css(
        "display",
        "none"
      );
      $(".wd-compare-detail-item-product-choose-select-mobile").css(
        "display",
        "none"
      );
      $(".wd-compare-detail-item-product-choose-card-popup-close").css(
        "display",
        "none"
      );
      $("html").css("overflow", "auto");
      $(".wd-compare").css("z-index", "auto");
    }
  );

  $(".wd-compare-detail-item-product-choose-card-item").click(function () {
    if (
      $(this).hasClass(
        "wd-compare-detail-item-product-choose-card-item-choosed"
      )
    ) {
      return false;
    }
    if (window_width <= 1024) {
      $(this)
        .parents(".wd-compare-detail-items")
        .find(".wd-compare-detail-item-product-choose-card")
        .stop()
        .slideUp();
      $(".wd-compare").css("z-index", "auto");
    }
    if (window_width <= 767) {
      $(this)
        .parents(".wd-compare-detail-items")
        .find(".wd-compare-detail-item-product-choose-card")
        .stop()
        .slideUp();
      $(".wd-compare-detail-item-product-choose-card-popup").css(
        "display",
        "none"
      );
      $(".wd-compare-detail-item-product-choose-select-mobile").css(
        "display",
        "none"
      );
      $(".wd-compare-detail-item-product-choose-card-popup-close").css(
        "display",
        "none"
      );
      $("html").css("overflow", "auto");
    }

    var data_index = $(this).attr("data-index");
    if (data_index !== pre_index) {
      $(".wd-compare-detail-item-product-choose-card-items")
        .find(`[data-index="${pre_index}"]`)
        .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
      pre_index = data_index;
    }
    $(this)
      .siblings()
      .removeClass("wd-compare-detail-item-product-choose-card-item-active");
    $(this).addClass("wd-compare-detail-item-product-choose-card-item-active");
    $(this).removeClass(
      "wd-compare-detail-item-product-choose-card-item-choosed"
    );
    $(this)
      .parents(".wd-compare-detail-item")
      .siblings()
      .find(".wd-compare-detail-item-product-choose-card-item")
      .each(function () {
        if ($(this).attr("data-index") === data_index) {
          $(this).addClass(
            "wd-compare-detail-item-product-choose-card-item-choosed"
          );
        }
      });

    var product_title = $(this)
      .find(".wd-compare-detail-item-product-choose-card-item-title")
      .html()
      .trim();

    $(this)
      .parents(".wd-compare-detail-item-product-choose")
      .find(
        ".wd-compare-detail-item-product-choose-select .wd-compare-detail-item-product-choose-name"
      )
      .html(product_title);

    $(this)
      .parents(".wd-compare")
      .find(".wd-compare-header-item")
      .eq(wd_compare_index)
      .find(".wd-compare-header-item-title")
      .html(product_title);
    var product_value = $(this).data("value");
    if(wd_compare_index  == 2 || wd_compare_index  == 4){
      $.ajax({
        type: "GET",
        url: "/products/" + product_value + ".js",
        dataType: "json",
        success: function (product) {
          var goods_price = (product.variants[1].price / 100).toFixed(2);
          var goods_url = product.url;
          $(".wd-compare-product .wd-compare-detail-item")
            .eq(wd_compare_index)
            .find(".wd-compare-detail-item-product-price")
            .html("$" + goods_price);
          $(".wd-compare-header .wd-compare-header-item")
            .eq(wd_compare_index)
            .find(".wd-compare-header-item-price")
            .html("$" + goods_price);
        },
      });
    }else{
      $.ajax({
        type: "GET",
        url: "/products/" + product_value + ".js",
        dataType: "json",
        success: function (product) {
          var goods_price = (product.variants[0].price / 100).toFixed(2);
          var goods_url = product.url;
          $(".wd-compare-product .wd-compare-detail-item")
            .eq(wd_compare_index)
            .find(".wd-compare-detail-item-product-price")
            .html("$" + goods_price);
          $(".wd-compare-header .wd-compare-header-item")
            .eq(wd_compare_index)
            .find(".wd-compare-header-item-price")
            .html("$" + goods_price);
        },
      });
    }
    

    edit_info(product_title);
  });

  function edit_info(title) {
    if (title == "TK") {
      $(".wd-compare-header .wd-compare-header-item")
        .eq(wd_compare_index)
        .find(".wd-compare-header-item-img img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/ui-wd-tk.png?v=1681803574"
        );
      $(".wd-compare-product .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-product-img img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/ui-wd-tk.png?v=1681803574"
        );
      $(".wd-compare-product .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-product-shop a")
        .attr("href", "https://www.waterdropfilter.com/products/wd-tank-king");
      $(".wd-compare-detail-accessories .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
        <div class="wd-compare-detail-item-text">
                            Lid*1<br><br>
                            Upper chamber*1<br><br>
                            Lower chamber*1<br><br>
                            Carbon filter*2<br><br>
                            Wrench*1<br><br>
                            Water level spigot*1
                        </div>
        `);
      $(".wd-compare-detail-material .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-text")
        .html(`0.8mm thickened stainless steel`);
      $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
      <div class="wd-compare-detail-item-text">
      2.25-gallon
  </div>`);
      $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `<div class="wd-compare-detail-item-text">
          One hour per barrel
      </div>`
        );
      $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        16 x 9.7 x 9.3 inches
                        </div>`
        );

      $(".wd-compare-detail-item_weight .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-text">
          9.88 pounds
      </div>
          `
        );
      $(".wd-compare-detail-with_stand .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
  </div>
        `);
      $(".wd-compare-detail-filter .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-longtext">
                            Natural Coconut Activated Carbon
                        </div>
          `
        );
      $(".wd-compare-detail-reduce_substance .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-longtext">
          Up to 98.95% of chlorine reduction. Also reduces heavy metals, sediment, rust, soil, and other impurities.
      </div>
          `
        );
      $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
        <div class="wd-compare-detail-item-a">
        <a href="https://www.waterdropfilter.com/products/bb9-2-black-purification-elements-replacement-water-filter">
            <div class="wd-compare-detail-item-img">
                <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/waterdrop-BB9-1.png?v=1624954332"
                    alt="">
            </div>
            <div class="wd-compare-detail-item-text">
                WD-BB9-2
            </div>
            <div class="wd-compare-detail-item-text">
                6,000 gallons
            </div>
        </a>
    </div>
    `);
    } else if (title == "TK-F") {
      $(".wd-compare-header .wd-compare-header-item")
        .eq(wd_compare_index)
        .find(".wd-compare-header-item-img img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/ui-wd-tk-f.png?v=1681803574"
        );
      $(".wd-compare-product .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-product-img img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/ui-wd-tk-f.png?v=1681803574"
        );
      $(".wd-compare-product .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-product-shop a")
        .attr(
          "href",
          "https://www.waterdropfilter.com/products/wd-tank-king?variant=39556619862098"
        );
      $(".wd-compare-detail-accessories .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
        <div class="wd-compare-detail-item-text">
                            Lid*1<br><br>
                            Upper chamber*1<br><br>
                            Lower chamber*1<br><br>
                            Carbon filter*2<br><br>
                            Wrench*1<br><br>
                            Water level spigot*1<br><br>
                            Non-slip stand*1
                        </div>
        `);
      $(".wd-compare-detail-material .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-text")
        .html(`0.8mm thickened stainless steel`);
      $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
      <div class="wd-compare-detail-item-text">
      2.25-gallon
  </div>`);
      $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `<div class="wd-compare-detail-item-text">
          Two hours per barrel
      </div>`
        );
      $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        16 x 9.7 x 9.3 inches
                        </div>`
        );

      $(".wd-compare-detail-item_weight .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-text">
          9.88 pounds
      </div>
          `
        );
      $(".wd-compare-detail-with_stand .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
  </div>
        `);
      $(".wd-compare-detail-filter .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-longtext">
          Natural Coconut Activated Carbon & Resin
                        </div>
          `
        );
      $(".wd-compare-detail-reduce_substance .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-longtext">
          Up to 98.95% of chlorine reduction. Also reduces heavy metals, sediment, rust, soil, and other impurities.
      </div>
          `
        );
      $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
        <div class="wd-compare-detail-item-a">
                            <a href="https://www.waterdropfilter.com/products/bb9-2-black-purification-elements-replacement-water-filter">
                                <div class="wd-compare-detail-item-img">
                                    <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/waterdrop-BB9-1.png?v=1624954332"
                                        alt="">
                                </div>
                                <div class="wd-compare-detail-item-text">
                                    WD-BB9-2
                                </div>
                                <div class="wd-compare-detail-item-text">
                                    6,000 gallons
                                </div>
                            </a>
                        </div>
                        <div class="wd-compare-detail-item-a">
                            <a href="https://www.waterdropfilter.com/products/replacement-for-gravity-fed-filtration-systems-pf-2%C2%AE">
                                <div class="wd-compare-detail-item-img">
                                    <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/600x600.1.png?v=1646831229"
                                        alt="">
                                </div>
                                <div class="wd-compare-detail-item-text">
                                    WD-PF-2
                                </div>
                                <div class="wd-compare-detail-item-text">
                                    1,000 gallons
                                </div>
                            </a>
                        </div>
    `);
    } else if (title == "TK-S") {
      $(".wd-compare-header .wd-compare-header-item")
        .eq(wd_compare_index)
        .find(".wd-compare-header-item-img img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/ui-wd-tk-s.png?v=1679903455"
        );
      $(".wd-compare-product .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-product-img img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/ui-wd-tk-s.png?v=1679903455"
        );
      $(".wd-compare-product .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-product-shop a")
        .attr(
          "href",
          "https://www.waterdropfilter.com/products/wd-tank-king-f-s"
        );
      $(".wd-compare-detail-accessories .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
        <div class="wd-compare-detail-item-text">
        Lid*1<br><br>
        Upper chamber*1<br><br>
        Lower chamber*1<br><br>
        Carbon filter*2<br><br>
        Wrench*1<br><br>
        Water level spigot*1<br><br>
        Non-slip stand*1<br><br>
    </div>
        `);
      $(".wd-compare-detail-material .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-text")
        .html(`0.8mm thickened stainless steel`);
      $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
      <div class="wd-compare-detail-item-text">
      2.25-gallon
  </div>`);
      $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `<div class="wd-compare-detail-item-text">
          One hour per barrel
      </div>`
        );
      $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        16 x 10 x 9.5 inches
                        </div>`
        );

      $(".wd-compare-detail-item_weight .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-text">
          11.62 pounds
      </div>
          `
        );
      $(".wd-compare-detail-with_stand .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">
      </div>
        `);
      $(".wd-compare-detail-filter .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-longtext">
          Natural Coconut Activated Carbon
                        </div>
          `
        );
      $(".wd-compare-detail-reduce_substance .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-longtext">
          Up to 98.95% of chlorine reduction. Also reduces heavy metals, sediment, rust, soil, and other impurities.
      </div>
          `
        );
      $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
        <div class="wd-compare-detail-item-a">
        <a href="https://www.waterdropfilter.com/products/bb9-2-black-purification-elements-replacement-water-filter">
            <div class="wd-compare-detail-item-img">
                <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/waterdrop-BB9-1.png?v=1624954332"
                    alt="">
            </div>
            <div class="wd-compare-detail-item-text">
                WD-BB9-2
            </div>
            <div class="wd-compare-detail-item-text">
                6,000 gallons
            </div>
        </a>
    </div>
    `);
    } else if (title == "TK-FS") {
      $(".wd-compare-header .wd-compare-header-item")
        .eq(wd_compare_index)
        .find(".wd-compare-header-item-img img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/ui-wd-tk-fs.png?v=1679036938"
        );
      $(".wd-compare-product .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-product-img img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/ui-wd-tk-fs.png?v=1679036938"
        );
      $(".wd-compare-product .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-product-shop a")
        .attr(
          "href",
          "https://www.waterdropfilter.com/products/wd-tank-king-f-s"
        );
      $(".wd-compare-detail-accessories .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
        <div class="wd-compare-detail-item-text">
                            Lid*1<br><br>
                            Upper chamber*1<br><br>
                            Lower chamber*1<br><br>
                            Carbon filter*2<br><br>
                            Fluoride filter*2<br><br>
                            Wrench*1<br><br>
                            Water level spigot*1<br><br>
                            Non-slip stand*1
                        </div>
        `);
      $(".wd-compare-detail-material .wd-compare-detail-item")
        .eq(wd_compare_index)
        .find(".wd-compare-detail-item-text")
        .html(`0.8mm thickened stainless steel`);
      $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
      <div class="wd-compare-detail-item-text">
      2.25-gallon
  </div>`);
      $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `<div class="wd-compare-detail-item-text">
          Two hours per barrel
      </div>`
        );
      $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        16 x 10 x 9.5 inches
                        </div>`
        );

      $(".wd-compare-detail-item_weight .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-text">
          11.62 pounds
      </div>
          `
        );
      $(".wd-compare-detail-with_stand .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">
  </div>
        `);
      $(".wd-compare-detail-filter .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-longtext">
          Natural Coconut Activated Carbon & Resin
                        </div>
          `
        );
      $(".wd-compare-detail-reduce_substance .wd-compare-detail-item")
        .eq(wd_compare_index)
        .html(
          `
          <div class="wd-compare-detail-item-longtext">
          Up to 98.95% of chlorine reduction. Also reduces heavy metals, sediment, rust, soil, and other impurities.
      </div>
          `
        );
      $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
        wd_compare_index
      ).html(`
        <div class="wd-compare-detail-item-a">
                            <a href="https://www.waterdropfilter.com/products/bb9-2-black-purification-elements-replacement-water-filter">
                                <div class="wd-compare-detail-item-img">
                                    <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/waterdrop-BB9-1.png?v=1624954332"
                                        alt="">
                                </div>
                                <div class="wd-compare-detail-item-text">
                                    WD-BB9-2
                                </div>
                                <div class="wd-compare-detail-item-text">
                                    6,000 gallons
                                </div>
                            </a>
                        </div>
                        <div class="wd-compare-detail-item-a">
                            <a href="https://www.waterdropfilter.com/products/replacement-for-gravity-fed-filtration-systems-pf-2%C2%AE">
                                <div class="wd-compare-detail-item-img">
                                    <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/600x600.1.png?v=1646831229"
                                        alt="">
                                </div>
                                <div class="wd-compare-detail-item-text">
                                    WD-PF-2
                                </div>
                                <div class="wd-compare-detail-item-text">
                                    1,000 gallons
                                </div>
                            </a>
                        </div>
    `);
    }
  }
});
